'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useModal;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("../ui/Modal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useModal(title, content) {
  const [modalContent, setModalContent] = (0, _react.useState)(content ? {
    title,
    content
  } : null);
  const onClose = (0, _react.useCallback)(() => setModalContent(null), []);
  const modal = (0, _react.useMemo)(() => {
    if (modalContent === null) return null;
    const {
      title,
      content
    } = modalContent;
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      onClose: onClose,
      title: title
    }, content);
    return output;
  }, [modalContent, onClose]);
  const showModal = (0, _react.useCallback)((title, getContent) => {
    setModalContent({
      content: getContent(onClose),
      title
    });
  }, [onClose]);
  return [modal, showModal];
}
